import { render, staticRenderFns } from "./ProductTableMobile.html?vue&type=template&id=34583006&external"
import script from "./ProductTableMobile.js?vue&type=script&lang=js&external"
export * from "./ProductTableMobile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports